import { getToken } from "../../backend/StorageUtils";
import { profileRoutes } from "../../constants/Routes";

const axios = require("axios");

export const getProfile = async (username, isLoggedInUserProfile) => {
	try {
		if (!isLoggedInUserProfile) {
			delete axios.defaults.headers.common["Authorization"];
		}
		let response = await axios.post(profileRoutes.walletProfile, {
			username,
		});
		if (!isLoggedInUserProfile) {
			axios.defaults.headers.common["Authorization"] = getToken();
		}
		var responseJson = response.data;
		if (!responseJson.success) throw new Error();

		return responseJson;
	} catch (err) {
		console.log(err);
		return null;
	}
};

export const updateProfile = async (fieldsToUpdate) => {
	try {
		axios.defaults.headers.common["Authorization"] = getToken();
		let fieldsToUpdateCleared = Object.fromEntries(
			Object.entries(fieldsToUpdate).filter(([_, v]) => v != null)
		);
		let response = await axios.put(profileRoutes.walletProfile, {
			...fieldsToUpdateCleared,
		});
		var responseJson = response.data;
		if (!responseJson.success) throw new Error();
		return responseJson;
	} catch (err) {
		return null;
	}
};
